export const QUOTE_STATUS = {
    CONVERTED: '1',
    OPEN: '3',
    PROCESSING: '4'
};

export const SOURCE_SYSTEMS = {
    SFCC: 'SFCC',
    CF:'CF',
    VOL: 'VOL'
};